import _toConsumableArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import pageMixin from "../mixins/page";
import Axios from "axios";
import TrialSheetModal from "./TrialSheetModal";
import TableDetailModal from "./TableDetailModal";
export default {
  name: "trial-sheet",
  mixins: [pageMixin],
  components: {
    TrialSheetModal: TrialSheetModal,
    TableDetailModal: TableDetailModal
  },
  data: function data() {
    return {
      searchText: "",
      columns: [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "试用类别",
        // width: 160,
        width: 110,
        sortable: true,
        key: "category"
      }, {
        title: "试用单位",
        key: "customer",
        sortable: true
      }, {
        title: "点数",
        width: 80,
        key: "point_num",
        sortable: true
      }, {
        title: "产品名称",
        sortable: true,
        key: "product_details",
        render: function render(h, params) {
          return h('span', params.row.product_details ? params.row.product_details.product_name : "");
        }
      }, {
        title: "状态",
        width: 80,
        sortable: true,
        key: "status"
      }, {
        title: "过期时间",
        width: 110,
        sortable: true,
        key: "expire_date"
      }, {
        title: "备注",
        key: "remark"
      }, {
        title: "操作",
        width: 100,
        align: 'center',
        slot: 'btns'
      }],
      data: [],
      selection: [],
      showCreateModal: false,
      showUpdateModal: false,
      // 申请详情
      showTableDetail: false,
      tableDetail: {},
      tableDetailColumns: [{
        title: "ID",
        key: "id"
      }, {
        title: "试用类别",
        key: "category"
      }, {
        title: "试用单位",
        key: "customer"
      }, {
        title: "申请时间",
        key: "create_at"
      }, {
        title: "申请人",
        key: "create_by",
        render: function render(h, params) {
          return h('span', params.row.create_by ? params.row.create_by.username : "");
        }
      }, {
        title: "点数",
        key: "point_num"
      }, {
        title: "产品名称",
        key: "product_details",
        render: function render(h, params) {
          return h('span', params.row.product_details ? params.row.product_details.product_name : "");
        }
      }, {
        title: "状态",
        key: "status"
      }, {
        title: "过期时间",
        key: "expire_date"
      }, {
        title: "备注",
        key: "remark"
      }, {
        title: "审核备注",
        key: "review_remark"
      }]
    };
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      var _this = this;
      var onFinish = this.setLoading.bind(this, false);
      this.setLoading(true);
      Axios.get("trials/my/", {
        params: {
          name: this.searchText,
          order_by: '-id',
          //默认按照id倒序，一般来说新建的申请排在前面
          page: this.currentPage,
          per_page: this.pageSize
        }
      }).then(function (resp) {
        _this.data = resp.data.trials;
        _this.setPageVars(resp.data.page_info);
      }).then(onFinish, onFinish);
    },
    onModalClose: function onModalClose(val) {
      val && this.refresh();
    },
    onSelectionChange: function onSelectionChange(rows) {
      var _this$selection;
      this.selection.length = 0;
      (_this$selection = this.selection).push.apply(_this$selection, _toConsumableArray(rows));
    },
    viewDetails: function viewDetails(rows) {
      // let detail = encodeURI(encodeURI(JSON.stringify(rows)))
      // window.open('tableDetail.html?detail=' + detail)
      this.tableDetail = rows;
      this.showTableDetail = true;
    }
  }
};